// Device detection utility for mobile access control
export const isMobileDevice = (): boolean => {
  if (typeof window === 'undefined') return false;
  
  const userAgent = window.navigator.userAgent.toLowerCase();
  const mobileKeywords = [
    'android', 'webos', 'iphone', 'ipad', 'ipod', 
    'blackberry', 'windows phone', 'mobile', 'tablet'
  ];
  
  return mobileKeywords.some(keyword => userAgent.includes(keyword)) || 
         window.innerWidth <= 768;
};

export const checkMobileAccess = (allowedRoutes: string[] = ['/']): boolean => {
  if (!isMobileDevice()) return true;
  
  const currentPath = window.location.pathname;
  return allowedRoutes.some(route => currentPath.startsWith(route));
};